<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">申请BU：</div>
            <div class="item-text">{{ data.sub_bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">任务名称：</div>
            <div class="item-text">{{ data.task_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请理由：</div>
            <div class="item-text">{{ data.reason }}</div>
        </div>
         <div class="form-item" v-show="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result }}</div>
        </div>
        
        <!-- <sliderHistoty :data="data.cancel" :listdata="logList"></sliderHistoty> -->

        <!-- 审核 -->
        <div v-if="data.process_status==206 && $route.name!='my-application'"  v-form:apply-cancel>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import sliderHistoty from "src/components/slider/slider_history.vue"
    import { getAllTemp } from 'src/control/common.js';  //公共方法
    import { mapGetters,mapState } from "vuex"

    export default {
        props:["sliderArg","data","resub","examine"],
        components:{
            sliderHistoty,
        },
        data(){
            return {

            }
        },


        computed:{
            ...mapState(["apply"]),
            tempTask(){  //详情任务的任务模板
				let tempId = this.data.template_id;
				return  tempId?getAllTemp(tempId):{};
            },
            logList(){
                let logArr = this.data.cancel || [];
                let len = logArr.length;
                let res = [];

                for(let i=0;i<len;i++){
                    let count = [];
                    let item = logArr[i];
                    let next = logArr[i+1];
                    item.reason = item.log_content;
                    count.push(item);
                    if(len >= 2 && next && (next.log_from == 6 || next.log_from ==7) ){
                        next.reason = next.log_content;
                        count.push(next);
                        i++;
                    }   
                    res.unshift(count);
                }

                return res;

                // return logArr.reduce((res,item,index)=>{
                //     let count = [];
                //     let next = logArr[index+1];

                //     item.reason = item.log_content
                //     count.push(item);
                //     if(len >= 2 && next && (next.log_from == 6 || next.log_from ==7) ){
                //         next.reason = next.log_content;
                //         count.push(next);
                //     }   
                //     res.unshift(count);
                //     return res;
                // },[]); 

                // for(let i in req){
                //     console.log(req);
                //     if(len<2){
                //         break;
                //     }
                //     req[i].reason = req[i].log_content;
                //     count.push(req[i]);
                //     if(count.length == 2 || (req[i+1].log_from == 6 || req[i+1].log_from == 7) ){
                //         arr.unshift(count);
                //         count = [];
                //     }
                // }
                
                // // this.newestLog = arr.shift();

                // console.log("进cancel了");
                // return arr.slice(1);
            },
            newestLog(){   //最新的log字符串数组
                let arr = this.logList[0];
                if(arr){
                    return arr.map(item=>{
                        return item.reason;
                    });
                }
                return [];
            },
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("budget-again");
                    this.$form.clear("apply-cancel");
                }
            },
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-cancel");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
            },
            checkNotPass(){
                let res = this.$form.check("apply-cancel");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// slider_cancelTask.vue?5c5dc10d